var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Steps',{attrs:{"stepNum":3}}),_c('Card4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }